import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const QUERY_KEY = 'GET_CONTACT_BY_ROLE_ID';
interface Params {
  id?: string;
}

interface RoleContacts {
  id: string;
  title: string;
  count: number;
}


const useGetContactsByRoleIdQuery = ({ id }: Params) => {
  const { data, isLoading, isSuccess } = useQuery(
    [QUERY_KEY, id],
    () =>
      api.get(API_URL.CONTACTS_COUNT_BY_ROLE, {
        params: {
          role_id: id,
        },
      }),
    {
      retry: 0,
      enabled: !!id,
    }
  );

  const formattedData = useMemo<RoleContacts[] | null>(() => {
    if (!data?.data) {
      return null;
    }
    const currentData = data?.data || [];
    return currentData.map((item, index) => ({
      // It's possible to have two orgs with the same name
      id: `${index}`,
      title: item.org_name || '',
      count: item.count || 0,
    }));
  }, [data?.data]);

  const total = useMemo(() => {
    return formattedData?.reduce((result, item) => {
      return result + (item.count || 0);
    }, 0);
  }, [formattedData]);

  const isEmpty = useMemo(() => {
    return formattedData?.length === 0 || !formattedData;
  }, [formattedData]);

  return {
    isEmpty,
    total,
    isLoading,
    data: formattedData,
    isSuccess,
  };
};

export default useGetContactsByRoleIdQuery;
